import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { layoutQuery } from "#modules/layouts/infra/layout.query";
import { invalidateOptimizedMaterialCosts } from "#modules/optimizations/infra/invalidateOptimizedMaterialCosts";
import { updateOptimizationNesting } from "#modules/optimizations/infra/updateOptimizationNesting.api";

export const useUpdateOptimizationNesting = ({
  quoteRequestId,
  lineIds,
}: {
  quoteRequestId: string;
  lineIds: string[];
}) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: updateOptimizationNesting,
    onSuccess: ({ layoutId }) => {
      invalidateOptimizedMaterialCosts(queryClient, quoteRequestId, lineIds);
      return queryClient.invalidateQueries(layoutQuery(layoutId));
    },
    onError: (err) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
  });

  return { updateOptimizationNesting: mutate, ...rest };
};
